import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _BudgetCostingCenter, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { BasicTable, MASK_BOOLEAN_ICON } from "../../../../theme/Component/BasicTable";
import { SelectBudgetID } from "../../../../admin/configuracion/BudgetID/SelectBudgetID";
import { SelectAccountantTree } from "../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";

interface Props {
    idCostingCenter: number;
}

export const BudgetCostingCenter = ({ idCostingCenter }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_BudgetCostingCenter);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalEdit, setModalEdit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        getLista()
    }, [idCostingCenter])

    const getLista = () => {

        instance.getBudgetCostingCenterCatalog(idCostingCenter).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                } else {
                    toast.error('NO hay datos')
                }

            }
        )
    }


    const create = () => {
        setBean({
            ReplaceBudgetID: false,
        });
        setModal({ ...modal, "view": true, "name": "Crear Modelo Contable" });
    }


    const deleteItem = () => {
        instance.deleteBudgetCostingCenter(bean.IDBudgetCostingCenter).then(
            (resp) => {
                getLista();
                setModalC({ ...modal, "view": false });
            }
        ).catch(
            (err => {
                console.log(err)
            })
        )
    }


    const editaItem = () => {
        instance.updateBudgetCostingCenter(bean).then(
            (resp) => {
                getLista();
                setModalEdit({ ...modalEdit, "view": false })
            }
        ).catch(err => { console.log(err) })
    }

    const createBudgetCosting = () => {
        if (!bean.BudgetIDStr || !bean.ExpAccountantIDStr) {
            toast.error('Seleccione un Rubro Presupuestal y una Cuenta Contable de Costo')
        }
        else {
            instance.addBudgetCostingCenter(idCostingCenter, bean.BudgetIDStr, bean.ExpAccountantIDStr).then(
                (resp) => {
                    getLista();
                    setModal({ ...modal, "view": false })
                }
            ).catch(err => { console.log(err) })
        }
    }

    const head = [
        { title: 'ID', property: 'IDBudgetCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        // { title: 'Core/Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Cuenta Contable Costo', property: 'ExpAccountantIDName', visible: true },
        { title: 'Reemplazar Rubro Presupuestal', property: 'ReplaceBudgetID', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Rubro Presupuestal Destino', property: 'BudgetIDStrDestinity', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalEdit({ ...modalEdit, "view": true, "name": "Editar" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">

            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createBudgetCosting}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} label="Rubro Presupuestal" />
                        </div>
                        <div className="col-md-12">
                            <SelectAccountantTree label="Cuenta Contable de Costo" jsonCode={bean.ExpAccountantIDStr} onChange={(e) => setBean({ ...bean, "ExpAccountantIDStr": e.JsonCode })} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={() => {
                    if (bean.ExpAccountantIDStr) {
                        editaItem();
                    } else {
                        toast.error('Seleccione una Cuenta Contable de Costo');
                    }
                }} >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectAccountantTree label="Cuenta Contable de Costo" jsonCode={bean.ExpAccountantIDStr} onChange={(e) => setBean({ ...bean, "ExpAccountantIDStr": e.JsonCode })} />
                        </div>
                        <div className="col-md-12">
                            <BasicSwitch estado={bean.ReplaceBudgetID ?? false} eventChange={(e) => { setBean({ ...bean, "ReplaceBudgetID": e }) }} label="Reemplazar Rubro Presupuestal" />
                        </div>

                        {bean.ReplaceBudgetID &&
                            <div className="col-md-12">
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStrDestinity": e.JsonCode }) }} jsonCode={bean.BudgetIDStrDestinity} label="Rubro Presupuestal Destino" />
                            </div>
                        }
                    </div>
                </Modal>
            </div>
        </div>
    )
}